module.exports = "/_next/static/images/4556c4e39451fb60bf6f04e1411cc051-cardHasArrivedDebit.svg";